import { Input, Switch } from '@mantine/core'
import { IconSearch } from 'components/icons/IconSearch'
import { translate } from 'i18n/i18n'
import React from 'react'
import { colors } from '../../settings/colors'
import { VirtualizedList } from '../VirtualizedList/VirtualizedList'

type THierarchicalSelectionProps<T> = {
  height?: number
  placeholder?: string
  searchString?: string
  setSearchString?: (searchString?: string) => void
  setShowOnlyChecked?: (showOnlyChecked: boolean) => void
  showOnlyChecked?: boolean
  title?: string
  width?: number | string
  items: T[]
  renderItem: React.ComponentType<{ index: number; style: React.CSSProperties; data: T[] }>
}

export const HierarchicalSelection = <T,>({
  height = 300,
  placeholder,
  searchString,
  setSearchString,
  setShowOnlyChecked,
  showOnlyChecked,
  title,
  width = 300,
  items,
  renderItem,
}: THierarchicalSelectionProps<T>) => {
  return (
    <div
      className="hierarchical-selection"
      css={{
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1 auto',
        maxWidth: width,
        minHeight: height,
      }}
    >
      <div
        css={{
          alignItems: 'center',
          display: 'flex',
          padding: '4px 10px',
          transition: '0.15s ease all',
        }}
      >
        <div css={{ fontWeight: 'bold', fontSize: 16 }}>{title}</div>
        {!!setSearchString && (
          <Input
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchString(e.target.value ?? '')}
            placeholder={placeholder}
            css={{ marginLeft: 10 }}
            value={searchString ?? ''}
            leftSection={<IconSearch />}
          />
        )}
        {!!setShowOnlyChecked && (
          <div
            css={{
              display: 'flex',
              marginLeft: 6,
              whiteSpace: 'nowrap',
              borderRadius: 3,
              padding: '4px 8px 4px 4px',
            }}
          >
            <Switch
              checked={showOnlyChecked}
              label={<div>{translate.phrases.banyanApp('Show Only Checked')}</div>}
              onChange={() => setShowOnlyChecked(!showOnlyChecked)}
            />
          </div>
        )}
      </div>

      <div css={{ border: `1px solid ${colors.grey200}` }}>
        <VirtualizedList height={height} items={items} renderItem={renderItem} />
      </div>
    </div>
  )
}
